<template>
  <div class="container pa-0 ma-0">
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container>
      <gestion-tiempos />
    </v-container>
  </div>
</template>

<script>
import GestionTiempos from "../components/GestionTiempos/GestionTiempos.vue";
import LandingToolbar from "../components/LandingToolbar/LandingToolbar.vue";
export default {
  components: { GestionTiempos, LandingToolbar },
};
</script>
<style scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
